import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MaskedLink } from '../../../components/internal/MaskedLink/index.js';
export const LinkItem = ({
  url,
  masked,
  children,
  target = '_blank',
  rel = 'noreferrer'
}) => {
  if (url) {
    return masked ? _jsx(MaskedLink, {
      href: url,
      target: target,
      rel: rel,
      children: children
    }) : _jsx("a", {
      href: url,
      target: target,
      rel: rel,
      children: children
    });
  } else {
    return children;
  }
};